import { render, staticRenderFns } from "./Prazos.vue?vue&type=template&id=0931757f&"
import script from "./Prazos.vue?vue&type=script&lang=js&"
export * from "./Prazos.vue?vue&type=script&lang=js&"
import style0 from "./Prazos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports